import React from 'react'
import {Offcanvas} from 'react-bootstrap'
import {LeadByID} from '../../leadTypes'
import {LeadSummaryPanel} from '../LeadSummaryPanel'
import {LeadActivityTab} from '../../../oneLead/components/LeadActivityTab'

interface IActivityListProps {
  lead: LeadByID
  children: JSX.Element
}

export const ActivityListLead: React.FC<IActivityListProps> = ({children, lead}) => {
  return (
    <>
      <Offcanvas.Header closeButton className='bg-light'>
        <Offcanvas.Title>{lead.name}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {children}
        <div className='lead-summary-layout'>
          <div className='lead-summary lead-summary-sticky'>
            <LeadSummaryPanel lead={lead} />
          </div>
          <div className='lead-summary-content'>
            <LeadActivityTab id={lead.id} />
          </div>
        </div>
      </Offcanvas.Body>
    </>
  )
}
